import React, { useMemo } from 'react';
import './HomeScreen.css';
import { LogType } from '../interfaces/LogType';
import StatistikWidget from '../components/StatsWidget';

interface HomeScreenProps {
  logs: LogType[];
  userName: string;
}

const HomeScreen: React.FC<HomeScreenProps> = ({ logs, userName }) => {
  const currentTime = new Date().getHours();
  const greeting =
    currentTime < 12
      ? 'Guten Morgen'
      : currentTime < 18
      ? 'Guten Tag'
      : 'Guten Abend';

  const calculateStats = (droneType: string) => {
    const filteredLogs = logs.filter((log) => log.droneType === droneType);

    if (filteredLogs.length === 0) {
      return {
        flightTime: '0h 0m',
        flightCount: 0,
        maxHeight: 0,
        maxSpeed: 0,
      };
    }

    const totalFlightTimeMinutes = filteredLogs.reduce((total, log) => {
      const start = new Date(log.startTime);
      const end = new Date(log.endTime);
      return total + (end.getTime() - start.getTime()) / 60000;
    }, 0);

    const maxAltitude = Math.max(
      ...filteredLogs.map((log) => log.heightMax || 0)
    );
    const maxSpeedMs = Math.max(
      ...filteredLogs.map((log) => log.xSpeedMax || 0)
    );
    const maxSpeedKmh = Math.round(maxSpeedMs * 3.6);

    return {
      flightTime: `${Math.floor(totalFlightTimeMinutes / 60)}h ${Math.round(
        totalFlightTimeMinutes % 60
      )}m`,
      flightCount: filteredLogs.length,
      maxHeight: maxAltitude,
      maxSpeed: maxSpeedKmh,
    };
  };

  const mavicStats = useMemo(() => calculateStats('DJI Mavic 2EA'), [logs]);
  const matriceStats = useMemo(
    () => calculateStats('DJI Matrice 350RTK'),
    [logs]
  );

  return (
    <div className="start-page-container">
      <div className="start-header">
        <h1>DRK Esslingen Flug Center</h1>
      </div>
      <div className="drone-statistic-section">
        <div>
          <div className="stats-images">
            <img
              src="/img/M2AE.webp"
              alt="DJI Mavic 2EA Bild 1"
              className="stat-img"
            />
          </div>
          <h2 className='drone-stats-title'>DJI Mavic 2EA</h2>
          <StatistikWidget droneType={69} verticalLayout />
        </div>
        <div>
          <div className="stats-images">
            <img
              src="/img/M350.webp"
              alt="DJI Matrice 350RTK Bild 1"
              className="stat-img"
            />
          </div>
          <h2 className='drone-stats-title'>DJI Matrice 350RTK</h2>
          <StatistikWidget droneType={'Matrice350RTK'} verticalLayout />
        </div>
      </div>

      <div className="links-section">
        <h2>Wichtige Links</h2>
        <ul>
          <li>
            <a
              href="https://maptool-dipul.dfs.de/?language=de"
              target="_blank"
              rel="noopener noreferrer"
            >
              DIPUL Karte
            </a>
          </li>
          <li>
            <a
              href="https://live.drohne.es/"
              target="_blank"
              rel="noopener noreferrer"
            >
              DRK Esslingen Streaming Portal
            </a>
          </li>
          <li>
            <a
              href="https://www.dwd.de/DE/wetter/warnungen_gemeinden/warnWetter_node.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              Deutscher Wetterdienst
            </a>
          </li>
          <li>
            <a
              href="https://www.hiorg-server.de/?ov=essl"
              target="_blank"
              rel="noopener noreferrer"
            >
              HI-Org
            </a>
          </li>
          <li>
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSexUyhWRnV1Hfimm6RFrQdxxtoxhl4_y8Vr-8XxmTfTUNGq1g/viewform?usp=dialog"
              target="_blank"
              rel="noopener noreferrer"
            >
              Bug Report & Feature Request
            </a>
          </li>
        </ul>
      </div>

      <StatistikWidget isLocation={true} />
    </div>
  );
};

export default HomeScreen;
